<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title">
    {{ "CommonAppoinment.suggestedSlot" | translate }}
  </h6>
  <span
    aria-label="Close"
    class="close"
    (click)="onNoClick()"
    data-automation-attribute="span-close-dialog"
  >
    <mat-icon matTooltip="{{ 'CommonAppoinment.suggestedSlot' | translate }}"
      >clear</mat-icon
    >
  </span>
</div>
<div>
  <form
    [formGroup]="formQuicKsearch"
    novalidate
    class="mt-10"
    attr.data-automation-attribute="formUserPersonalDetails"
  >
    <div>
      <label class="patient-name-label" margin-top="10px">{{
        "CommonAppoinment.appointmentDate" | translate
      }}</label>
    </div>
    <mat-grid-list
      cols="3"
      rowHeight="60px"
      style="margin-top: 3px; margin-right: 5px"
    >
      <mat-grid-tile [colspan]="1">
        <mat-label>{{ "CommonAppoinment.dateRange" | translate }}</mat-label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ "pharmacy.startDate" | translate }}</mat-label>
          <input
            matInput
            formControlName="fromDateRange"
            required
            [min]="minDate"
            [matDatepicker]="picker1"
            [placeholder]="'pharmacy.startDate' | translate"
            attr.data-automation-attribute="dateDOB"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </mat-grid-tile>

      <mat-grid-tile [colspan]="1">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ "EncounterPage.enddate" | translate }}</mat-label>
          <input
            matInput
            required
            [min]="minDate"
            formControlName="toDateRange"
            [matDatepicker]="picker2"
            [placeholder]="'EncounterPage.enddate' | translate"
            attr.data-automation-attribute="dateDOB"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="3" rowHeight="30px">
      <mat-grid-tile [colspan]="1">
        <mat-label style="margin-right: 35px">{{
          "CommonAppoinment.dateRestrictions" | translate
        }}</mat-label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="3" style="margin-left: 36px">
        <button
          mat-button
          (click)="selecteDays('Monday')"
          [ngStyle]="{
            'background-color': weekDaysList[1].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Mon
        </button>
        <button
          mat-button
          (click)="selecteDays('Tuesday')"
          [ngStyle]="{
            'background-color': weekDaysList[2].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Tue
        </button>
        <button
          mat-button
          (click)="selecteDays('Wednesday')"
          [ngStyle]="{
            'background-color': weekDaysList[3].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Wed
        </button>
        <button
          mat-button
          (click)="selecteDays('Thursday')"
          [ngStyle]="{
            'background-color': weekDaysList[4].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Thu
        </button>
        <button
          mat-button
          (click)="selecteDays('Friday')"
          [ngStyle]="{
            'background-color': weekDaysList[5].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Fri
        </button>
        <button
          mat-button
          (click)="selecteDays('Saturday')"
          [ngStyle]="{
            'background-color': weekDaysList[6].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Sat
        </button>
        <button
          mat-button
          (click)="selecteDays('Sunday')"
          [ngStyle]="{
            'background-color': weekDaysList[0].value == true ? '#39ab96' : ''
          }"
          mat-flat-button
        >
          Sun
        </button>
      </mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="3" rowHeight="65px" style="margin-right: 5px; margin-top: 10px;" >
      <mat-grid-tile [colspan]="1">
        <mat-label>{{ "CommonAppoinment.timeRange" | translate }}</mat-label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>From Time</mat-label>
          <input
            matInput
            type="time"
            style="height: fit-content"
            formControlName="fromTimeRange"
            matNativeControl
          />
        </mat-form-field>
      </mat-grid-tile>
      

      <mat-grid-tile [colspan]="1">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>To Time</mat-label>
          <input
            matInput
            type="time"
            style="height: fit-content"
            formControlName="fromToRange"
            matNativeControl
          />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
    <mat-grid-list cols="3" rowHeight="60px" style="margin-right: 5px">
      <mat-grid-tile [colspan]="1" style="margin-left: 15px">
        <mat-label>Doctor  :</mat-label>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1">

        <mat-form-field class="full-width" appearance="outline">
          <mat-label> Doctor</mat-label>
          <mat-select
            formControlName="doctor"
            placeholder="Select"
            data-automation-attribute="select-encounter-type"
          >
          <mat-option>
          <ngx-mat-select-search [formControl] ="doctorFltrCtrl" class="full-width" ngDefaultControl
           [placeholderLabel]="'RegistrationPage.search' | translate">
          </ngx-mat-select-search>
          </mat-option>
          <mat-option>{{"RegistrationPage.none"|translate}}</mat-option>
          <mat-option *ngFor="let doctor of doctorFilteredList" [value]="doctor">
              {{ doctor.desc }}
          </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" style="margin-left: 45px;">
        <button mat-button color="primary" (click)="search()">
          {{ "SearchHeader.search" | translate }}
        </button>
      </mat-grid-tile>
    </mat-grid-list>
  </form>

  <label class="patient-name-label"> Available Slots</label>
  <div class="height20" (scroll)="onTableScroll($event)">
    <table mat-table [dataSource]="dataSource" #table class="width100">
      <ng-container matColumnDef="dateTime">
        <th mat-header-cell *matHeaderCellDef>Date/Time</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.availableDate + ":" + element.availableStartTime }}
        </td>
      </ng-container>
      <ng-container matColumnDef="slotDuration">
        <th mat-header-cell *matHeaderCellDef>Slot Duration</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.slotDuration }}
        </td>
      </ng-container>
      <ng-container matColumnDef="doctororDept">
        <th mat-header-cell *matHeaderCellDef>Doctor / Specialty</th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          {{ element.doctor ? element.doctor : element.department }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        (click)="selectRow(i, row)"
        style="cursor: pointer"
      ></tr>
    </table>
    

    <div class="center" *ngIf="dataSource.data.length == 0 && noSlots == true">
      No slots available
    </div>
   
  </div>
  <div>
    <mat-grid-list cols="3"  rowHeight="35px" style="margin-right: 5px; margin-top: -50px;">
      <mat-grid-tile [colspan]="1"> </mat-grid-tile>
      <mat-grid-tile [colspan]="1"> </mat-grid-tile>
      <mat-grid-tile [colspan]="1" style="margin-left: 45px;">
        <button mat-button color="primary" (click)="clear()">
          {{ "common.clear" | translate }}
        </button>
      </mat-grid-tile>
    </mat-grid-list>
   
  </div>
 
</div>

<!-- <diV class="divbottom">
 
</diV> -->
